import type { FaireProductEntity } from "../../entity_types/product";

export const p_7q9e59penb: FaireProductEntity = {
  token: "p_7q9e59penb",
  type: "product",
  name: "ASYMMETRICAL OFF SHOULDER RUFFLES MIDI DRESS",
  brandToken: "b_uxq2uydaxj",
  brandName: "One and Only Collective",
  imageUrl:
    "https://cdn.faire.com/fastly/e15e9819327f5d795be1e63a5d5de7339de2a9c79eb66f6b22c62cae20e1e574.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/877a6c7352a90701a5af39e1855c71253243813bbfb8e5a13a2d8665e1bb4f3b.jpeg",
    "https://cdn.faire.com/fastly/c9d7184093cb97e686e253d72a98ed6ddb24cac36ba6369ba7bc1c2cdac55f94.jpeg",
  ],
  priceDollars: 39,
  description:
    "The midi dress has thin spaghetti straps paired with an off the shoulder silhouette. It has sculptural ruffle accents on the shoulders and high low asymmetrical hem with cascading ruffles.",
  tags: [],
  msrpDollars: 101.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:20:04.502Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
